/**
 * DateTime Control Component
 * Renders date and time picker
 */

import React from 'react';
import { Box } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { DatetimeSettings } from '../../../../types/ControlTypes';
import { BaseDateTimePicker } from '../BaseDateTimePicker';
import { LabelWithInfo } from './LabelWithInfo';

export const DatetimeControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  description,
  required,
  control,
}) => {
  const settings = control.settings as DatetimeSettings;
  const format = settings?.format || 'MM/dd/yyyy HH:mm';

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ mb: 1 }}>
        <LabelWithInfo
          label={label || name}
          description={description}
          required={required}
        />
      </Box>
      <BaseDateTimePicker
        views={['year', 'month', 'day', 'hours', 'minutes']}
        openTo="day"
        format={format}
        value={value ? dayjs(value) : null}
        onChange={(newValue: Dayjs | null) => {
          onChange(newValue ? newValue.format('YYYY-MM-DD HH:mm:ss') : null);
        }}
        disabled={disabled || readonly}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            error: !!error,
            helperText: error,
          },
        }}
      />
    </Box>
  );
};

export default DatetimeControl;
